/**
 * Location type code values. Only the ones that are needed for reference are
 * included in this file.
 */
export const LocationTypeCodes = {
    fixed: 'F',
    itinerant: 'I',
    meterControlStation: '6',
    mobile: 'M',
    temporaryFixed: 'T',
};
